/**
 * Triggered when search text field changes
 *
 * @param {Object} e - event object
 * @param {Array} options - array of options
 * @param {Function} setCheckBoxOptions - function to set checkbox options
 *
 * @requires react
 * @component @react/shared-component/CheckBoxGroup/View
 *
 * @returns {void} - returns nothing because we only change react setState value using this function
 */
function OnSearchTextFieldChange(e, options, setCheckBoxOptions) {
	// get searched term from the event
	const searchedTerm = e.target.value;

	// if searched term is empty, return all options
	if (searchedTerm === '') {
		setCheckBoxOptions(options);
	}

	// search the options and return found options
	const foundOptions = options.filter((option) => {
		return option.label.toLowerCase().includes(searchedTerm.toLowerCase());
	});

	// set found options to checkbox options
	setCheckBoxOptions(foundOptions);
}

export default OnSearchTextFieldChange;
